import { WifiOffOutlined } from '@material-ui/icons';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import LocalizationContext from '../../../contexts/LocalizationContext';
import AppHeader from '../../main/AppHeader';
import AppLayout from '../../main/AppLayout';
import BackButton from '../../main/BackButton';
import { AccountContext } from './context/AccountProvider';
import PersonalInfo from './sections/PersonalInfo';
import Preferences from './sections/Preferences';

const Account = () => {
    const account = useContext(AccountContext);
    const localization = useContext(LocalizationContext);
    const history = useHistory();

    return (
        <AppLayout>
            <AppHeader name={localization.strings.account.account} />
            <BackButton onClick={() => history.goBack()} />
            {!navigator.onLine || !account.account ? (
                <>
                    <WifiOffOutlined />
                    {localization.strings.account.offline}.
                </>
            ) : (
                <>
                    <PersonalInfo />
                    <Preferences />
                </>
            )}
        </AppLayout>
    );
};

export default Account;
